import React from 'react';

import { Theme, ThemedStyles, useStyles } from 'ui/base/theme';
import { CoreNavigation } from 'ui/core/navigation';

import { CoreBasePath } from 'services/base/page_path';
import { Pangolin } from 'services/accounts/types';

import baseStyles from './core_page.module.css';

type CorePageStyles = {
  container: string;
  background: string;
  content: string;
  navigation: string;
};

const themedStyles: ThemedStyles<CorePageStyles> = {
  [Theme.DAYLIGHT]: {
    container: baseStyles.container,
    background: baseStyles.daylightBackground,
    content: baseStyles.content,
    navigation: baseStyles.navigation,
  },
  [Theme.MIDNIGHT]: {
    container: baseStyles.container,
    background: baseStyles.midnightBackground,
    content: baseStyles.content,
    navigation: baseStyles.navigation,
  },
};

export type CorePageProps = {
  pangolin: Pangolin;
  location: CoreBasePath;
  children: React.ReactNode;
  onScroll?(event: React.UIEvent<HTMLDivElement>): void;
};

export const CorePage = React.memo(({ pangolin, location, children, onScroll }: CorePageProps) => {
  const styles = useStyles(themedStyles);
  return (
    <div className={styles.container}>
      <div className={styles.background} onScroll={onScroll}>
        <div className={styles.content}>
          {children}
        </div>
      </div>
      <div className={styles.navigation}>
        <CoreNavigation
          pangolin={pangolin}
          location={location}
        />
      </div>
    </div>
  );
});

CorePage.displayName = 'CorePage';
